module.exports = __webpack_public_path__ + "static/media/In a Dream.656a6127.jpg";